import React from 'react';

// style
import { SectionWrapper } from '../assets/styles/checkUID';

// asset
import CheckUidImage from '../assets/images/checkUID.png';

const CheckUID = React.forwardRef((props, ref) => (
    <SectionWrapper ref={ref}>
        <h1 className="sr-only">계정 UID 확인방법</h1>
        <img src={CheckUidImage} alt="계정 UID 확인방법 안내" />
    </SectionWrapper>
));

export default CheckUID;